import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class UploadInvoiceService {

    url = environment.FRAPPE_API_URL

    constructor(
        private http: HttpClient
    ) {
    }

    public uploadFile(url: string, file: File, args: any) {
        const formData: FormData = new FormData();
        formData.append('file', file, file.name);

        for (const [key, value] of Object.entries(args)) {
            if (typeof value === 'string' || value instanceof Blob) {
                formData.append(key, value);
            } else {
                formData.append(key, String(value));
            }
        }
        return this.http.post(url, formData);
    }

    public parsePdfInvoice(file: File): Observable<any> {
        const url = `${this.url}/api/method/vendor_portal.rest.parse_pdf_invoice`;
        const formData = new FormData();
        formData.append('file', file);
        return this.http.post(url, formData);
    }

}
